import { Controller, useForm } from "react-hook-form";
import { v4 as uuidv4 } from "uuid";
import { states } from "js/placeholderData/states";
import { screenScrollTo } from "js/utilities";
import FormInputError from "components/General/FormInputError";
import MaskedPhoneNumberInput from "components/General/Form/MaskedPhoneNumberInput";
import RELEASING_AutoCompleteComboBox from "components/General/AutoCompleteComboBox/RELEASING_AutoCompleteComboBox";
import { useTranslation } from "react-i18next";
import { useState } from "react";

export default function FACStepTwo({ formStep, setFormStep, setFACFormData }) {
  const uuid = uuidv4();
  const {
    register: FACStepTwoRegister,
    handleSubmit: FACStepTwoHandleSubmit,
    setValue,
    watch,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      informantType: "",
      phoneClaimer: "",
      faxNumberClaimer: "",
      funeralHomePhoneClaimer: "",
      funeralHomeFaxNumberClaimer: "",
    },
  });
  const { t } = useTranslation();
  const [selectedState, setSelectedState] = useState({
    value: "all",
  });

  const onSubmit = (data) => {
    // screenScrollTo();
    setFormStep(3);
    setFACFormData((currentFormData) => {
      return {
        ...currentFormData,
        ...data,
      };
    });
  };

  return (
    <>
      {formStep === 2 && (
        <>
          <p className="text-xs">{t("UnauthFACStep-two-subtitle")} </p>
          <form onSubmit={FACStepTwoHandleSubmit(onSubmit)}>
            <div>
              <hr />
              <div className="grid gap-4 grid-cols-1 lg:gap-6">
                <div className="grid gap-4 grid-cols-1 md:gap-y-0 md:gap-x-4 md:grid-cols-[2fr,2fr]">
                  <div>
                    <fieldset>
                      <legend className="font-bold">
                        {t("UnauthFACStep-two-informant")}
                      </legend>
                      <div className="inline-block mt-2 mr-6">
                        <label className="inline-flex items-center text-xs font-semibold">
                          <input
                            id={`${uuid}-informantType1`}
                            type="radio"
                            name="individual"
                            className="mr-1"
                            value="individual"
                            {...FACStepTwoRegister("informantType", {
                              required: "Please select an informant type",
                            })}
                          />{" "}
                          {t("UnauthFACStep-two-individual")}
                        </label>
                      </div>
                      <div className="inline-block mt-2 mr-6">
                        <label className="inline-flex items-center text-xs font-semibold">
                          <input
                            id={`${uuid}-informantType2`}
                            type="radio"
                            name="funeralHome"
                            className="mr-1"
                            value="funeralHome"
                            {...FACStepTwoRegister("informantType", {
                              required: "Please select an informant type",
                            })}
                          />{" "}
                          {t("UnauthFACStep-two-funeral")}
                        </label>
                      </div>
                      <FormInputError
                        id={`${uuid}-in-claimer-error`}
                        errorMessage={errors.informantType?.message}
                      />
                    </fieldset>
                  </div>
                </div>
                {watch("informantType") === "individual" && (
                  <>
                    <div className="grid gap-4 grid-cols-1 md:gap-y-0 md:gap-x-4 md:grid-cols-[2fr,2fr]">
                      <div>
                        <label
                          htmlFor={`${uuid}-in-claimer`}
                          className="block mb-1"
                        >
                          {t("UnauthFACStep-two-individual-nm")}
                        </label>
                        <input
                          id={`${uuid}-in-claimer`}
                          type="text"
                          placeholder="Informants Name"
                          {...FACStepTwoRegister("informantName", {
                            required: "Please enter a informant’s Name",
                          })}
                        />
                        <FormInputError
                          id={`${uuid}-in-claimer-error`}
                          errorMessage={errors.informantName?.message}
                        />
                      </div>

                      <div>
                        <label
                          htmlFor={`${uuid}-cn-claimer`}
                          className="block mb-1"
                        >
                          {t("UnauthFACStep-two-individual-company")}
                        </label>
                        <input
                          id={`${uuid}-cn-claimer`}
                          type="text"
                          placeholder="Company Name"
                          {...FACStepTwoRegister("companyName")}
                        />
                        <FormInputError
                          id={`${uuid}-cn-claimer-error`}
                          errorMessage={errors.companyName?.message}
                        />
                      </div>
                    </div>
                    <div>
                      <label
                        htmlFor={`${uuid}-ima-claimer`}
                        className="block mb-1"
                      >
                        {t("UnauthFACStep-two-individual-mailling")}
                      </label>
                      <input
                        id={`${uuid}-ima-claimer`}
                        type="text"
                        placeholder="Informants Address"
                        {...FACStepTwoRegister("individualMailingAddress")}
                      />
                      <FormInputError
                        id={`${uuid}-ima-claimer-error`}
                        errorMessage={errors.individualMailingAddress?.message}
                      />
                    </div>

                    <div>
                      <label
                        htmlFor={`${uuid}-ima2-claimer`}
                        className="block mb-1"
                      >
                        {t("UnauthFACStep-two-individual-mailling-2")}
                      </label>
                      <input
                        id={`${uuid}-ima2-claimer`}
                        type="text"
                        placeholder="Informants Address Line 2"
                        {...FACStepTwoRegister(
                          "individualMailingAddress2Claimer"
                        )}
                      />
                      <FormInputError
                        id={`${uuid}-sa2-claimer-error`}
                        errorMessage={
                          errors.individualMailingAddress2Claimer?.message
                        }
                      />
                    </div>
                    <div className="grid gap-4 grid-cols-1 md:gap-y-0 md:gap-x-4 md:grid-cols-[1.5fr,1fr,1fr]">
                      <div>
                        <label
                          htmlFor={`${uuid}-city-claimer`}
                          className="block mb-1"
                        >
                          {t("UnauthFACStep-two-individual-city")}
                        </label>
                        <input
                          id={`${uuid}-city-claimer`}
                          type="text"
                          placeholder="City"
                          {...FACStepTwoRegister(
                            "individualMailingCityClaimer"
                          )}
                        />
                        <FormInputError
                          id={`${uuid}-city-claimer-error`}
                          errorMessage={
                            errors.individualMailingCityClaimer?.message
                          }
                        />
                      </div>

                      <div>
                        <Controller
                          name="individualMailingStateClaimer"
                          control={control}
                          render={() => (
                            <RELEASING_AutoCompleteComboBox
                              labelName={t(
                                "UnauthFACStep-two-individual-state"
                              )}
                              inputPlaceholderText={t(
                                "UnauthFACStep-two-individual-state"
                              )}
                              options={[
                                {
                                  value: "all",
                                  displayAs: t(
                                    "UnauthFACStep-two-individual-state"
                                  ),
                                  selectedPolicyDisplayAs: t(
                                    "UnauthFACStep-two-individual-state"
                                  ),
                                  isDisplayOnly: true,
                                },
                                ...states.map((state) => ({
                                  value: state.abbreviation,
                                  displayAs: state.name,
                                  selectedPolicyDisplayAs: state.name,
                                  isDisplayOnly: true,
                                })),
                              ]}
                              selectedOption={selectedState}
                              setSelectedOption={(option) => {
                                setSelectedState(option);
                                if (option?.value !== "all") {
                                  setValue(
                                    "individualMailingStateClaimer",
                                    option.value
                                  );
                                } else {
                                  setValue("individualMailingStateClaimer", "");
                                }
                              }}
                            />
                          )}
                        />

                        <FormInputError
                          id={`${uuid}-state-claimer-error`}
                          errorMessage={
                            errors.individualMailingStateClaimer?.message
                          }
                        />
                      </div>

                      <div>
                        <label
                          htmlFor={`${uuid}-zip-claimer`}
                          className="block mb-1"
                        >
                          {t("UnauthFACStep-two-individual-zipcode")}
                        </label>
                        <input
                          id={`${uuid}-zip-claimer`}
                          type="text"
                          {...FACStepTwoRegister(
                            "individualMailingZipClaimer",
                            {
                              pattern: {
                                value: /^\d{5}$/,
                                message:
                                  "Please enter a valid zipcode (5 digits)",
                              },
                              maxLength: {
                                value: 5,
                                message:
                                  "Please enter only 5 digits for zipcode",
                              },
                            }
                          )}
                        />
                        <FormInputError
                          id={`${uuid}-zip-claimer-error`}
                          errorMessage={
                            errors.individualMailingZipClaimer?.message
                          }
                        />
                      </div>
                    </div>
                    <div className="grid gap-4 grid-cols-1 md:gap-y-0 md:gap-x-4 md:grid-cols-[2fr,2fr]">
                      <div>
                        <label
                          id={`${uuid}-phone-claimer`}
                          className="block mb-1"
                        >
                          {t("UnauthFACStep-two-individual-ph")}
                        </label>
                        <MaskedPhoneNumberInput
                          name="phoneClaimer"
                          describedby={`${uuid}-phone-claimer`}
                          register={FACStepTwoRegister}
                          setValue={setValue}
                        />
                        <FormInputError
                          id={`${uuid}-phone-claimer-error`}
                          errorMessage={errors.phoneClaimer?.message}
                        />
                      </div>
                      <div>
                        <label
                          id={`${uuid}-fax-claimer`}
                          className="block mb-1"
                        >
                          {t("UnauthFACStep-two-individual-fax")}
                        </label>
                        <MaskedPhoneNumberInput
                          name="faxNumberClaimer"
                          describedby={`${uuid}-fax-claimer`}
                          register={FACStepTwoRegister}
                          setValue={setValue}
                          required={false}
                        />
                        <FormInputError
                          id={`${uuid}-fax-claimer-error`}
                          errorMessage={errors.faxNumberClaimer?.message}
                        />
                      </div>
                    </div>
                    <div className="grid gap-4 grid-cols-1 md:gap-y-0 md:gap-x-4 md:grid-cols-[2fr,2fr]">
                      <div>
                        <label
                          htmlFor={`${uuid}-email-claimer`}
                          className="block mb-1"
                        >
                          {t("UnauthFACStep-two-individual-email")}
                        </label>
                        <input
                          id={`${uuid}-email-claimer`}
                          type="text"
                          {...FACStepTwoRegister("inEmailClaimer", {
                            required: {
                              value: false,
                              message: "Please enter email address.",
                            },
                            pattern: {
                              value:
                                /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
                              message: "Please enter a valid email",
                            },
                          })}
                        />

                        <FormInputError
                          id={`${uuid}-email-claimer-error`}
                          errorMessage={errors.inEmailClaimer?.message}
                        />
                      </div>
                      <div>
                        <label
                          htmlFor={`${uuid}-relationship-claimer`}
                          className="block mb-1"
                        >
                          {t("UnauthFACStep-two-individual-rd")}
                        </label>
                        <input
                          id={`${uuid}-relationship-claimer`}
                          type="text"
                          placeholder="Relationship"
                          {...FACStepTwoRegister("inRelationshipClaimer")}
                        />
                        <FormInputError
                          id={`${uuid}-inRelationship-claimer`}
                          errorMessage={errors.inRelationshipClaimer?.message}
                        />
                      </div>
                    </div>
                  </>
                )}
                {watch("informantType") === "funeralHome" && (
                  <>
                    <div className="grid gap-4 grid-cols-1 md:gap-y-0 md:gap-x-4 md:grid-cols-[2fr,2fr]">
                      <div>
                        <label
                          htmlFor={`${uuid}-fn-claimer`}
                          className="block mb-1"
                        >
                          {t("UnauthFACStep-two-funeral-home")}
                        </label>
                        <input
                          id={`${uuid}-fn-claimer`}
                          type="text"
                          {...FACStepTwoRegister("funeralName", {
                            required: "Please enter a name of funeral home",
                          })}
                        />
                        <FormInputError
                          id={`${uuid}-fn-claimer-error`}
                          errorMessage={errors.funeralName?.message}
                        />
                      </div>
                      <div>
                        <label
                          htmlFor={`${uuid}-en-claimer`}
                          className="block mb-1"
                        >
                          {t("UnauthFACStep-two-funeral-emp")}
                        </label>
                        <input
                          id={`${uuid}-en-claimer`}
                          type="text"
                          {...FACStepTwoRegister("employeeName")}
                        />
                        <FormInputError
                          id={`${uuid}-en-claimer-error`}
                          errorMessage={errors.employeeName?.message}
                        />
                      </div>
                    </div>
                    <div className="grid gap-4 grid-cols-1 md:gap-y-0 md:gap-x-4 md:grid-cols-[2fr,2fr]">
                      <div>
                        <label
                          id={`${uuid}-funeralHomePhone-claimer`}
                          className="block mb-1"
                        >
                          {t("UnauthFACStep-two-ph")}
                        </label>{" "}
                        <MaskedPhoneNumberInput
                          name="funeralHomePhoneClaimer"
                          describedby={`${uuid}-funeralHomePhone-claimer`}
                          register={FACStepTwoRegister}
                          setValue={setValue}
                        />
                        <FormInputError
                          id={`${uuid}-funeralHomePhone-claimer-error`}
                          errorMessage={errors.funeralHomePhoneClaimer?.message}
                        />
                      </div>
                    </div>
                    <div className="grid gap-4 grid-cols-1 md:gap-y-0 md:gap-x-4 md:grid-cols-[2fr,2fr]">
                      <div>
                        <fieldset>
                          <legend>
                            {t("UnauthFACStep-two-fh-assignment")}
                          </legend>

                          <div className="inline-block mt-2 mr-6">
                            <label className="inline-flex items-center text-sm font-normal">
                              <input
                                id={`${uuid}-foreign-1`}
                                type="radio"
                                className="mr-1"
                                value="yes"
                                {...FACStepTwoRegister("funeralHomeAssignment")}
                              />
                              {t("UnauthFACStep-two-label-1")}
                            </label>
                          </div>
                          <div className="inline-block mt-2 mr-6">
                            <label className="inline-flex items-center text-sm font-normal">
                              <input
                                id={`${uuid}-foreign-2`}
                                type="radio"
                                className="mr-1"
                                value="no"
                                {...FACStepTwoRegister("funeralHomeAssignment")}
                              />
                              {t("UnauthFACStep-two-label-2")}
                            </label>
                          </div>
                          <FormInputError
                            id={`${uuid}-foreign-error`}
                            errorMessage={errors.foreign?.message}
                          />
                        </fieldset>
                      </div>
                      <div>
                        <label
                          htmlFor={`${uuid}-fnAmountOfAssignment-claimer`}
                          className="block mb-1"
                        >
                          {t("UnauthFACStep-two-label-3")}
                        </label>
                        <input
                          id={`${uuid}-fnAmountOfAssignment-claimer`}
                          type="text"
                          {...FACStepTwoRegister("funeralAmountOfAssignment")}
                        />
                        <FormInputError
                          id={`${uuid}-fnAmountOfAssignment-claimer-error`}
                          errorMessage={
                            errors.funeralAmountOfAssignment?.message
                          }
                        />
                      </div>
                    </div>
                    <div className="grid gap-4 grid-cols-1 md:gap-y-0 md:gap-x-4">
                      <div>
                        <fieldset>
                          <legend>{t("UnauthFACStep-two-information")}</legend>

                          <div className="inline-block mt-2 mr-6">
                            <label className="inline-flex items-center text-sm font-normal">
                              <input
                                id={`${uuid}-sentToAboveInfo-1`}
                                type="radio"
                                className="mr-1"
                                value="yes"
                                {...FACStepTwoRegister(
                                  "funeralSentToAboveInfo"
                                )}
                              />
                              {t("UnauthFACStep-two-label-1")}
                            </label>
                          </div>
                          <div className="inline-block mt-2 mr-6">
                            <label className="inline-flex items-center text-sm font-normal">
                              <input
                                id={`${uuid}-sentToAboveInfo-2`}
                                type="radio"
                                className="mr-1"
                                value="no"
                                {...FACStepTwoRegister(
                                  "funeralSentToAboveInfo"
                                )}
                              />
                              {t("UnauthFACStep-two-label-2")}
                            </label>
                          </div>
                        </fieldset>
                      </div>
                    </div>
                  </>
                )}
                <div className="flex justify-end">
                  <button
                    className="ui-btn-secondary ui-btn-min-w mt-4"
                    type="button"
                    onClick={() => setFormStep((current) => current - 1)}
                  >
                    {t("UnauthFACStep-two-btn-1")}
                  </button>

                  <button className="ui-btn-primary ui-btn-min-w mt-4">
                    {t("UnauthFACStep-two-btn-2")}
                  </button>
                </div>
              </div>
            </div>
          </form>
        </>
      )}
    </>
  );
}
